// Auto-generated workout data imports
// This file consolidates all workout JSON files into a single importable module

import workout_14TmGHiqpC from './14TmGHiqpC.json';
import workout_1tViNkXwKQ from './1tViNkXwKQ.json';
import workout_3aJ8nMrgLd from './3aJ8nMrgLd.json';
import workout_3rLnRlTdQ3 from './3rLnRlTdQ3.json';
import workout_54dYn0oExU from './54dYn0oExU.json';
import workout_553lkiVNgV from './553lkiVNgV.json';
import workout_89HeFQSbGE from './89HeFQSbGE.json';
import workout_FML2PrDvkR from './FML2PrDvkR.json';
import workout_IX2uSFbGPZ from './IX2uSFbGPZ.json';
import workout_JpDMHRZtaB from './JpDMHRZtaB.json';
import workout_LGt8MqcvdQ from './LGt8MqcvdQ.json';
import workout_MzBfwwDxEB from './MzBfwwDxEB.json';
import workout_NkctG9Onu1 from './NkctG9Onu1.json';
import workout_OIoXe9I4bh from './OIoXe9I4bh.json';
import workout_PexwKSHyz6 from './PexwKSHyz6.json';
import workout_TBn7DwOwEc from './TBn7DwOwEc.json';
import workout_VBEbqmsmYl from './VBEbqmsmYl.json';
import workout_YBjIjxrpJ2 from './YBjIjxrpJ2.json';
import workout_aB01LoXAZk from './aB01LoXAZk.json';
import workout_bZIBbPzXc6 from './bZIBbPzXc6.json';
import workout_e0fpoQCSWR from './e0fpoQCSWR.json';
import workout_ereX1jTlGO from './ereX1jTlGO.json';
import workout_k0MlcITKGW from './k0MlcITKGW.json';
import workout_tJpZlAA0hq from './tJpZlAA0hq.json';
import workout_uLOWEcW9V1 from './uLOWEcW9V1.json';
import workout_vCBrff5o6l from './vCBrff5o6l.json';
import workout_xjx8cV9fzM from './xjx8cV9fzM.json';
import workout_xzCdnkKwU1 from './xzCdnkKwU1.json';

export const workoutData: Record<string, any> = {
  '14TmGHiqpC': workout_14TmGHiqpC,
  '1tViNkXwKQ': workout_1tViNkXwKQ,
  '3aJ8nMrgLd': workout_3aJ8nMrgLd,
  '3rLnRlTdQ3': workout_3rLnRlTdQ3,
  '54dYn0oExU': workout_54dYn0oExU,
  '553lkiVNgV': workout_553lkiVNgV,
  '89HeFQSbGE': workout_89HeFQSbGE,
  'FML2PrDvkR': workout_FML2PrDvkR,
  'IX2uSFbGPZ': workout_IX2uSFbGPZ,
  'JpDMHRZtaB': workout_JpDMHRZtaB,
  'LGt8MqcvdQ': workout_LGt8MqcvdQ,
  'MzBfwwDxEB': workout_MzBfwwDxEB,
  'NkctG9Onu1': workout_NkctG9Onu1,
  'OIoXe9I4bh': workout_OIoXe9I4bh,
  'PexwKSHyz6': workout_PexwKSHyz6,
  'TBn7DwOwEc': workout_TBn7DwOwEc,
  'VBEbqmsmYl': workout_VBEbqmsmYl,
  'YBjIjxrpJ2': workout_YBjIjxrpJ2,
  'aB01LoXAZk': workout_aB01LoXAZk,
  'bZIBbPzXc6': workout_bZIBbPzXc6,
  'e0fpoQCSWR': workout_e0fpoQCSWR,
  'ereX1jTlGO': workout_ereX1jTlGO,
  'k0MlcITKGW': workout_k0MlcITKGW,
  'tJpZlAA0hq': workout_tJpZlAA0hq,
  'uLOWEcW9V1': workout_uLOWEcW9V1,
  'vCBrff5o6l': workout_vCBrff5o6l,
  'xjx8cV9fzM': workout_xjx8cV9fzM,
  'xzCdnkKwU1': workout_xzCdnkKwU1,
};

/**
 * Get workout data by ID (replaces fetch calls)
 */
export const getWorkoutData = (workoutId: string): any | null => {
  return workoutData[workoutId] || null;
};